module.exports = __webpack_public_path__ + "img/blueCall.bf919443.svg";